export default "__VITE_ASSET__Dd8B_NtP__"